module.exports = __webpack_public_path__ + "static/media/webclub-logo-blue.f4acd85e.png";